import React, {useEffect, useState} from 'react';
import Key from '@mui/icons-material/Key';
import EmailSent from '@mui/icons-material/MarkEmailRead';
import {
  Box,
  Container,
  styled,
  alpha,
  Typography,
  TextField,
} from '@mui/material';
import theme from '../theme/theme';
import {useFormInput} from '../utils/utilities';
import {BackButton, CustomButton} from '../components';
import {useNavigate} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import {clearAuthError, forgotPassword, setEmailSentFalse} from '../actions';
import {fieldError, isFieldIvalid} from '../utils/errorHandler';

const ForgotPassword = () => {
  const dispatch = useDispatch();
  const {authLoading, sentResetPasswordEmail, authError} = useSelector(
    s => s.user,
  );
  const email = useFormInput('');
  const navigate = useNavigate();

  const onBack = () => {
    dispatch(setEmailSentFalse());
    navigate(-1);
  };

  const onSubmit = e => {
    e.preventDefault();
    dispatch(forgotPassword(email.value));
  };

  const errorMessage = () => {
    if (typeof authError === 'string' && authError !== '') {
      return authError;
    } else if (isFieldIvalid(authError, 'email')) {
      return fieldError(authError, 'email');
    }
    return '';
  };

  useEffect(() => {
    dispatch(clearAuthError());
  }, []);

  return (
    <form onSubmit={onSubmit}>
      <WrapContainer>
        <Box
          mb="2.5rem"
          width="6.25rem"
          height="6.25rem"
          display="flex"
          borderRadius="50%"
          alignItems="center"
          justifyContent="center"
          bgcolor={alpha(
            sentResetPasswordEmail
              ? theme.palette.success.light
              : theme.palette.primary.light,
            0.3,
          )}>
          {sentResetPasswordEmail ? (
            <EmailIcon color="success" />
          ) : (
            <KeyIcon color="primary" />
          )}
        </Box>
        <Typography variant="h4" fontWeight="bold" mb="0.5rem">
          {sentResetPasswordEmail ? 'Check your email' : 'Forgot password?'}
        </Typography>
        <Typography color="tertiary400">
          {sentResetPasswordEmail
            ? `We sent a password reset link to`
            : "No worries, we'll send you reset instructions."}
        </Typography>
        {sentResetPasswordEmail && (
          <Typography fontWeight="bold" color="tertiary400">
            {email.value}
          </Typography>
        )}
        <Box
          mt="3rem"
          mb="2rem"
          gap="1.2rem"
          width="25rem"
          display="flex"
          flexDirection="column">
          {!sentResetPasswordEmail && (
            <>
              <TextField
                {...email}
                required
                label="Email"
                disabled={authLoading}
                error={!!authError}
                helperText={errorMessage()}
              />
              <CustomButton loading={authLoading} type="submit">
                Reset password
              </CustomButton>
            </>
          )}
        </Box>
        <BackButton onClick={onBack} text="Back to log in" />
      </WrapContainer>
    </form>
  );
};

const WrapContainer = styled(Container)`
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const KeyIcon = styled(Key)`
  font-size: 3rem;
  transform: rotate(-30deg);
`;

const EmailIcon = styled(EmailSent)`
  font-size: 3rem;
`;

export default ForgotPassword;
